// src/components/IntercomProvider.js
import { useEffect } from 'react';

export default function IntercomProvider({ user }) {
  useEffect(() => {
    const bootIntercom = () => {
      if (!window.Intercom) return;

      const isInApp = window.location.pathname.startsWith("/app");

      const intercomSettings = user
        ? {
            app_id: 'w51btoii',
            user_id: user.airtable_id,
            name: user.prenom,
            email: user.email,
            created_at: Math.floor(new Date(user.createdAt).getTime() / 1000),
            hide_default_launcher: false, // 👈 Le widget est visible
            auto_open: !isInApp,          // 👈 N'ouvre pas automatiquement si on est dans /app
          }
        : {
            app_id: 'w51btoii',
            hide_default_launcher: false,
            auto_open: !isInApp,
          };

      window.Intercom('boot', intercomSettings);

      // ❌ Supprimé : plus d'ouverture automatique par défaut
      // window.Intercom('show');
    };

    if (!window.Intercom) {
      const script = document.createElement('script');
      script.src = 'https://widget.intercom.io/widget/w51btoii';
      script.async = true;
      script.onload = bootIntercom;
      document.body.appendChild(script);
    } else {
      bootIntercom();
    }

    return () => {
      if (window.Intercom) {
        window.Intercom('shutdown');
      }
    };
  }, [user]);

  return null;
}